import { CarVideoDto } from "api"
import NextImage from "common/bit/NextImage"
import styled from "styled-components"
import colors from "theme/colors"
import {
  StyledCol,
  StyledDividerV,
  StyledRow,
  StyledSvgIcon,
  TypographyRtl,
} from "theme/shared"

const StyledCardWrap = styled.div`
  width: 316px;
  height: 316px;
  top: 0;
  left: 0;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
`
const StyledImageContainer = styled.div`
  height: 100%;
  position: relative;
`
const StyledGradientOverlay = styled.div`
  position: absolute;
  bottom: -2px;
  left: 0;
  background: linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0.2) 100%);
  width: 100%;
  height: 100%;
`
const StyledCardContent = styled.div`
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  padding: 25px;
  flex-direction: column;
  justify-content: space-between;
  display: flex;
`
type VideoCardProps = {
  data?: CarVideoDto
  selectedModel?: string
}

const VideoCard = ({ data, selectedModel }: VideoCardProps) => {
  return (
    <StyledCardWrap>
      <StyledImageContainer>
        <NextImage
          image={{
            imageUrl: data?.previewPicture || "/img/placeholder.jpeg",
            alt: data?.name || "video-img",
          }}
        />
        <StyledGradientOverlay />
        <StyledCardContent>
          <StyledRow $fullWidth $gap="10px">
            <StyledDividerV $color={colors.mazdaRed} $width={5} $radius={3} />
            <StyledCol $notCenter>
              <TypographyRtl $color={colors.white} variant="h2">
                {selectedModel}
              </TypographyRtl>
              <TypographyRtl $color={colors.white} variant="caption">
                {data?.name}
              </TypographyRtl>
            </StyledCol>
          </StyledRow>
          <StyledCol $fullWidth $notCenter>
            <StyledSvgIcon
              src="/icons/big-play-icon.svg"
              alt="play-button"
              $w={50}
              $h={50}
            />
            <TypographyRtl $color={colors.white} variant="caption" $mt="5px">
              {data?.description}
            </TypographyRtl>
          </StyledCol>
        </StyledCardContent>
      </StyledImageContainer>
    </StyledCardWrap>
  )
}

export default VideoCard
